export default function Nodata({ text }) {
  return <p className="empty">{text}</p>;
};
